import { httpCreate } from './http';

const http = httpCreate('/srv/gather-statistics-area/');

export const gatherStatisticsArea = {
	// 获取省份数据
	getProvince(albumId, params) {
		return http.get(`/${albumId}/province`, { params });
	},
	// 获取省份百分比
	/**
	 * @param { Number } albumId
	 * @param { Number } params.isTotal
	 */
	getProvincePercent(albumId, params) {
		return http.get(`/${albumId}/province/percent`, { params });
	},
	// 获取城市百分比
	/**
	 * @param { Number } albumId
	 * @param { Number } params.isTotal
	 */
	getCityPercent(albumId, params) {
		return http.get(`/${albumId}/city`, { params });
	},
	// 省份城市明细
	getCity(albumId, provinceId, params) {
		return http.get(`/${albumId}/city/${provinceId}`, { params });
	},
};
